export default __webpack_public_path__ + "static/media/legendheat.56ef572e.svg";